<template>
  <div class="view-toggle">
    <div class="segmented">
      <div class="track">
        <v-chip color="white" class="chip" :class="chipClass" />
        <button
          v-for="opt in options"
          :key="opt.value"
          @click="selectOption(opt.value)"
          v-ripple
          class="segment"
          :class="{ 'is-active': value === opt.value }">
          <span class="label" :class="{ active: value === opt.value }">
            {{ opt.text }}
          </span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ViewToggle',
  props: {
    value: { type: String, required: true },
    options: {
      type: Array,
      required: true,
      validator: (arr) =>
        arr.length === 2 &&
        arr.every((o) => o != null && 'value' in o && 'text' in o),
    },
  },
  computed: {
    isFirstOptionSelected() {
      return this.options[0]?.value === this.value
    },
    chipClass() {
      return this.isFirstOptionSelected ? 'left' : 'right'
    },
  },
  methods: {
    selectOption(value) {
      if (value !== this.value) {
        this.$emit('input', value)
      }
    },
  },
}
</script>

<style scoped>
.view-toggle {
  display: inline-block;
}

.segmented {
  display: inline-block;
}

.track {
  --track-width: 320px;
  --track-height: 48px;
  position: relative;
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: stretch;
  width: var(--track-width);
  height: var(--track-height);
  background: var(--v-primary-base);
  border-radius: 9999px;
  padding: 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12) inset;
  overflow: hidden;
}

.chip.v-chip {
  --track-control-padding: 6px;
  --chip-width: calc(50% - calc(var(--track-control-padding) * 2));
  --chip-height: calc(var(--track-height) - 2 * var(--track-control-padding));
  --chip-border-radius: calc(var(--chip-height) / 2);
  position: absolute;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.12);
  transition: left 80ms ease, width 80ms ease;
  border-radius: var(--chip-border-radius);
  width: var(--chip-width);
  height: var(--chip-height);
  top: var(--track-control-padding);
  left: var(--track-control-padding);
}

.chip.right {
  left: calc(50% + var(--track-control-padding));
}

.segment {
  position: relative;
  z-index: 1;
  background: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 12px;
  outline: none;
}

.label {
  color: rgba(255, 255, 255, 0.7);
  font-weight: 500;
  font-size: 0.875rem;
  transition: color 80ms ease;
  white-space: nowrap;
}

.label.active {
  color: var(--v-primary-base);
}
</style>
